import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';

@Component({
  selector: 'app-table-action-buttons',
  templateUrl: './table-action-buttons.component.html',
  styleUrls: ['./table-action-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableActionButtonsComponent extends ComponentAbstract implements OnInit {
  @Input() rowReference: Object;
  @Input() currentRowReference;
  @Input() disableEdit = false;
  @Input() disableSave = false;
  @Input() disableDelete = false;
  @Input() lockFields = false;
  @Input() allowDelete = true;
  @Input() allowEdit = true;

  @Output() editEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() saveEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() deleteEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(protected cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit(): void {}

  edit($event: Event) {
    $event.stopPropagation();
    this.editEvent.emit();
  }

  save($event: Event) {
    $event.stopPropagation();
    this.saveEvent.emit();
  }

  delete($event: Event) {
    $event.stopPropagation();
    this.deleteEvent.emit();
  }
}
